import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  boxTop: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2)
  },
  sectionTitle: {
    flexGrow: 1,
    fontWeight: 600
  }
}));

export default useStyles;
